var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:_vm.className,style:(_vm.styles),attrs:{"outlined":"","rounded":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"me-2 font-weight-regular"},[_vm._v(" "+_vm._s(_vm.$t(_vm.btnText))+" ")]),(_vm.iconName)?_c('my-icon-image',{attrs:{"name":_vm.iconName,"maxWidth":_vm.iconWidth}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }